<template>
  <iframe v-bind:src="source" hidden frameborder="0"></iframe>
</template>

<script>
export default {
  data() {
    return {
      source: ""
    };
  },
  methods: {
    downloadFile(source) {
      this.$set(this, "source", source);
    }
  }
};
</script>